import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    tarjetaId: 0,
    banco: '',
    tarjetaMarca: '',

    id: 0,
    titular: '',
    numero: '',
    credito: true,
    fechaVigenciaHasta: new Date(),
    inactivo: false,
    rowVersion: null,
    
    tarjetaPlasticoDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_TARJETA_PLASTICO'(state, params) {
        state.tarjetaId = params.tarjetaId;
        state.banco = '';
        state.tarjetaMarca = '';
    
        state.id = params.tarjetaPlasticoId;
        state.titular = '';
        state.numero = '';
        state.credito = true;
        state.fechaVigenciaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_TARJETA'(state, tarjeta) {
        state.banco = tarjeta.banco;
        state.tarjetaMarca = tarjeta.tarjetaMarca;
    },
    'SET_TARJETA_PLASTICO'(state, tarjetaPlastico) {
        state.banco = tarjetaPlastico.banco;
        state.tarjetaMarca = tarjetaPlastico.tarjetaMarca;

        state.titular = tarjetaPlastico.titular.trim();
        state.numero = tarjetaPlastico.numero.trim();
        state.credito = (/true/i).test(tarjetaPlastico.credito);
        state.fechaVigenciaHasta = moment(tarjetaPlastico.fechaVigenciaHasta).format('YYYY-MM-DD');
        state.inactivo = (/true/i).test(tarjetaPlastico.inactivo);
        state.rowVersion = tarjetaPlastico.rowVersion;
    },

    'INICIALIZAR_TARJETA_PLASTICO_DATOS' (state) {
        state.tarjetaPlasticoDatos = [];
    },
    'SET_TARJETA_PLASTICO_DATOS' (state, tarjetaPlasticoDatos) {
        state.tarjetaPlasticoDatos = tarjetaPlasticoDatos;
    }
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TARJETA_PLASTICO', params);
            
            if (params.tarjetaPlasticoId != 0) {
                apiAxios.get('tarjetas-plasticos/' + params.tarjetaPlasticoId + '/abm') 
                .then(res => {
                    commit('SET_TARJETA_PLASTICO', res.data);
                    resolve();                
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                apiAxios.get('tarjetas/' + params.tarjetaId) 
                .then(res => {
                    commit('SET_TARJETA', res.data);
                    resolve();                
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        }, error => {
            reject(error);
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let tarjetaPlastico = {
                tarjetaId: parseInt(state.tarjetaId),
                titular: state.titular.toUpperCase().trim(),
                numero: state.numero.toUpperCase().trim(),
                credito: (/true/i).test(state.credito),
                fechaVigenciaHasta: moment(state.fechaVigenciaHasta).format('YYYY-MM-DD'),
                inactivo: (/true/i).test(state.inactivo)
            }

            let url = 'tarjetas-plasticos';
            if (state.id != 0) {
                tarjetaPlastico.rowVersion = state.rowVersion;
                url += '/' + state.id;
            }

            apiAxios.post(url, tarjetaPlastico)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getTarjetaPlasticoDatos ( { commit }, tarjetaPlasticoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TARJETA_PLASTICO_DATOS');

            if (tarjetaPlasticoId != 0) {
                apiAxios.get('tarjetas-plasticos/' + tarjetaPlasticoId ) 
                .then(res => {
                    let tarjetaPlasticoDatos = [
                        { 'nombre': 'banco', 'campo': 'Banco', 'valor': res.data.banco, 'formato': '' },
                        { 'nombre': 'tarjetaMarca', 'campo': 'Marca', 'valor': res.data.tarjetaMarca, 'formato': '' },
                        { 'nombre': 'titular', 'campo': 'Titular', 'valor': res.data.titular, 'formato': '' },
                        { 'nombre': 'numero', 'campo': 'Número', 'valor': res.data.numero, 'formato': '' },
                        { 'nombre': 'fechaVigenciaHasta', 'campo': 'Vigencia Hasta', 'valor': res.data.fechaVigenciaHasta , 'formato': 'periodo' },
                        { 'nombre': 'credito', 'campo': 'Crédito', 'valor': res.data.credito ? 'Si' : 'No' , 'formato': '' },
                        { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': res.data.inactivo ? 'Si' : 'No' , 'formato': '' },
                    ];
                    
                    commit('SET_TARJETA_PLASTICO_DATOS', tarjetaPlasticoDatos);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            
        }, error => {
            reject(error);
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}